<template>
    <section v-if="$hasFeature('INBOX')" class="alert-notification tw:flex tw:items-center">
        <div class="is-stripped tw:flex tw:items-center tw:bg-transparent! tw:border-none!" @click="showAlertDrawer">
            <div class="is-relative tw:flex tw:items-center tw:mr-2">
                <e-icon icon="pi pi-bell" class="alert-notification-icon tw:text-[var(--text-color)]" />
                <div v-show="notificationsCounter !== 0" class="badge" :class="$isMobile ? 'is-mobile' : ''">
                    <p>{{ notificationsCounter }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'AlertNotification',
    computed: {
        ...mapState('Auth', { user: state => state.user }),

        open() {
            return this.$store.state.alertDrawer;
        },
        notificationsCounter() {
            return this.$store.state.entities.bell_notifications.counter;
        },
    },
    methods: {
        showAlertDrawer() {
            this.$store.commit('SET_ALERT_DRAWER', { state: !this.open });
        },
    },
};
</script>

<style lang="scss" scoped>
.alert-notification-icon {
    width: 20px !important;
    height: 20px !important;
    font-size: 20px !important;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
}

.badge {
    left: 12px;
}
</style>
